// extracted by mini-css-extract-plugin
module.exports = {"renderWrapper":"c_R","renderContainer":"c_S","tabletContainer":"c_T"};